export default {
  strict: true,
  namespaced: true,
  state: {
    list: [],
    selected: {
      flights: {
        oneway: [],
        return: []
      },
      currency: {}
    },
    rsvp1: {},
    rsvp2: {},
    rsvp3: {},
    rsvp4: {},
    availableGround: []
  },
  mutations: {
    setFlightData (state, data) {
      for (let field in data) {
        state[field] = data[field]
      }
    },
    addAvailableGround (state, val) {
      state.availableGround = state.availableGround.concat(val)
    },
    addFlightList (state, data) {
      state.list = state.list.concat(data)
    },
    sortList (state) {
      state.list.sort((a, b) => {
        return b.dateSort - a.dateSort
      })
    }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/flights/list.js